import { Component, Input, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators
} from '@angular/forms';


@Component({
  selector: 'app-color-picker-input',
  templateUrl: './color-picker-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerInputComponent),
      multi: true
    }
  ]
})
export class ColorPickerInputComponent {
  @Input() label: string = 'Choose Color';
  @Input() formGroup: FormGroup;
  @Input() key: string;


  hexPattern = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  selectedColor: string = ''

  ngOnInit(): void {
    this.formGroup.get(this.key).setValidators([Validators.required, Validators.pattern(this.hexPattern)]);
    this.formGroup.get(this.key).updateValueAndValidity();
    this.selectedColor = this.formGroup.get(this.key).value ?? '#000000';
    this.formGroup.get(this.key).valueChanges.subscribe((value) => {
      this.selectedColor = value;
    })
  }

  constructor() {
  }


  // --- UI Triggers ---

  onNativeColorInput(event: string): void {
    // const input = event.target as HTMLInputElement;
    if (event) {
      this.formGroup.get(this.key).setValue(event.toUpperCase());
      this.formGroup.get(this.key).updateValueAndValidity();
      this.formGroup.get(this.key).markAsTouched();
      this.formGroup.get(this.key).markAsDirty();
      this.formGroup.updateValueAndValidity();
    }
  }

}